import '@stylesheets/application'
import { initApp } from '@app'

initApp().mount('#app')
